<template>
	<div class="company-detail-container">
		<div class="conpany-detail-content">
			<!-- 企业信息卡片--start -->
			<div class="conpany-card">
				<div class="company-info-left">
					<div class="company-logo">
						<img src="@/assets/employment/companyLogo.png" alt="公司logo" />
					</div>
					<div class="company-info-content">
						<div class="company-name-wrapper">
							<h1 class="company-name">XXXXXX建筑设计有限公司</h1>
							<div class="company-join-time">入驻时间：2024-07-08</div>
						</div>
						<div class="company-meta">
							<span class="meta-item">国有企业-监理</span>
							<span class="meta-item">429人以上</span>
							<span class="meta-item">武汉市-洪山区</span>
						</div>
						<div class="company-tags">
							<span class="company-tag">五险一金</span>
							<span class="company-tag">交通补助</span>
							<span class="company-tag">节日福利</span>
							<span class="company-tag">定期体检</span>
							<span class="company-tag">...</span>
						</div>
					</div>
				</div>
				<div class="company-info-right">
					<div class="job-count">
						<span class="count-num">12</span>
						<span class="count-text">在招职位</span>
					</div>
					<button type="button" class="collect-btn">
						<svg-icon icon-class="collect"></svg-icon>
						点击收藏
					</button>
				</div>
			</div>
			<!-- 企业信息卡片--end -->

			<div class="section-detail-wrapper">
				<!-- 左侧信息 -->
				<div class="section-detail-left">
					<div class="section-detail">
						<!-- 基本信息 -->
						<div class="section-dot-title loose">基本信息</div>
						<div class="section-info">
							<div class="info-row">
								<div class="info-item">
									<span class="info-label">法定代表人：</span>
									<span class="info-value">刘海军</span>
								</div>
								<div class="info-item">
									<span class="info-label">注册资本：</span>
									<span class="info-value">1000W</span>
								</div>
							</div>
							<div class="info-row">
								<div class="info-item">
									<span class="info-label">成立日期：</span>
									<span class="info-value">2001-02-24</span>
								</div>

								<div class="info-item">
									<span class="info-label">企业类型：</span>
									<span class="info-value">股份有限公司分公司（上市、国有控股）</span>
								</div>
							</div>
							<div class="info-row">
								<div class="info-item">
									<span class="info-label">经营行业：</span>
									<span class="info-value">建筑装饰、装修和其他建筑业</span>
								</div>
							</div>
						</div>

						<!-- 企业简介 -->
						<div class="section-dot-title loose">企业简介</div>
						<div class="section-info">
							<p>输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字输入一段文字</p>
						</div>

						<!-- 办公地址 -->
						<div class="section-dot-title loose">办公地址</div>
						<div class="section-info">
							<p>输入一段文字输入一段文字输入一段文字输入一段文字</p>
						</div>

						<!-- 企业画像 -->
						<div class="section-dot-title loose">企业画像</div>
						<div class="section-info">
							<div class="tab-pane-container">
								<!-- tab头部区域--start -->
								<div class="tab-pane-header">
									<!-- tab选项 -->
									<div class="tab-pane-navs">
										<div
											v-for="(item, index) in compantTabs"
											:key="index"
											:class="['tab-pane-item', { active: activeTab === index }]"
											@click="activeTab = index"
										>
											{{ item.name }}
											<!-- 数字标签 -->
											<span class="tab-pane-item-badge">{{ item.num }}</span>
										</div>
									</div>
								</div>
								<!-- tab头部区域--end -->
								<!-- tab内容区域--start -->
								<div class="tab-pane-content">
									<!-- 企业资质内容区域--start -->
									<div :class="['tab-pane-content__item', { active: activeTab === 0 }]">
										<jr-table
											:table-data="qualificationAllList"
											:column="qualificationColumns"
											:page-hide="true"
											:index="true"
											size="small"
										></jr-table>
									</div>
									<!-- 企业资质内容区域--end -->
									<!-- 项目业绩内容区域--start -->
									<div :class="['tab-pane-content__item', { active: activeTab === 1 }]">项目业绩内容区域</div>
									<!-- 项目业绩内容区域--end -->
									<!-- 诚信记录内容区域--start -->
									<div :class="['tab-pane-content__item', { active: activeTab === 2 }]">诚信记录内容区域</div>
									<!-- 诚信记录内容区域--end -->
								</div>
							</div>
						</div>

						<!-- 招聘职位 -->
						<div class="section-dot-title loose">招聘职位</div>
						<div class="position-content">
							<div class="position-list-other">
								<div class="position-item">
									<h3 class="position-title">PMC注册安全工程师</h3>
									<div class="position-meta">
										<span class="position-salary">15K~20K</span>
										<span class="position-location">武汉-洪山区</span>
										<span class="position-education">本科</span>
										<span class="position-experience">3~5年</span>
									</div>
								</div>

								<div class="position-item">
									<h3 class="position-title">PMC注册安全工程师</h3>
									<div class="position-meta">
										<span class="position-salary">15K~20K</span>
										<span class="position-location">武汉-洪山区</span>
										<span class="position-education">本科</span>
										<span class="position-experience">3~5年</span>
									</div>
								</div>

								<div class="position-item">
									<h3 class="position-title">PMC注册安全工程师</h3>
									<div class="position-meta">
										<span class="position-salary">15K~20K</span>
										<span class="position-location">武汉-洪山区</span>
										<span class="position-education">本科</span>
										<span class="position-experience">3~5年</span>
									</div>
								</div>

								<div class="position-item">
									<h3 class="position-title">PMC注册安全工程师</h3>
									<div class="position-meta">
										<span class="position-salary">15K~20K</span>
										<span class="position-location">武汉-洪山区</span>
										<span class="position-education">本科</span>
										<span class="position-experience">3~5年</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 右侧信息 -->
				<div class="section-detail-right">
					<div class="recommendation-card">
						<div class="section-simple-title">
							<h4>推荐企业</h4>
						</div>

						<div class="recommendation-company-list">
							<div class="company-item">
								<h3 class="company-name">XXXXXX建筑设计有限公司</h3>
								<div class="company-meta">
									<span>100-499人</span>
									<span>|</span>
									<span>国有企业</span>
									<span>|</span>
									<span>房地产开发商</span>
								</div>
								<div class="company-jobs">
									<div class="job-names">
										<span class="job-name">项目经理</span>
										<span class="job-name">专业监理</span>
										<span class="job-name">专业监理1</span>
									</div>

									<div class="job-count">
										<span class="num">12个</span>
										热招职位
									</div>
								</div>
							</div>

							<div class="company-item">
								<h3 class="company-name">XXXXXX建筑设计有限公司</h3>
								<div class="company-meta">
									<span>100-499人</span>
									<span>|</span>
									<span>国有企业</span>
									<span>|</span>
									<span>房地产开发商</span>
								</div>
								<div class="company-jobs">
									<div class="job-names">
										<span class="job-name">项目经理</span>
										<span class="job-name">专业监理</span>
										<span class="job-name">专业监理1</span>
									</div>

									<div class="job-count">
										<span class="num">12个</span>
										热招职位
									</div>
								</div>
							</div>

							<div class="company-item">
								<h3 class="company-name">XXXXXX建筑设计有限公司</h3>
								<div class="company-meta">
									<span>100-499人</span>
									<span>|</span>
									<span>国有企业</span>
									<span>|</span>
									<span>房地产开发商</span>
								</div>
								<div class="company-jobs">
									<div class="job-names">
										<span class="job-name">项目经理</span>
										<span class="job-name">专业监理</span>
										<span class="job-name">专业监理1</span>
									</div>

									<div class="job-count">
										<span class="num">12个</span>
										热招职位
									</div>
								</div>
							</div>

							<div class="company-item">
								<h3 class="company-name">XXXXXX建筑设计有限公司</h3>
								<div class="company-meta">
									<span>100-499人</span>
									<span>|</span>
									<span>国有企业</span>
									<span>|</span>
									<span>房地产开发商</span>
								</div>
								<div class="company-jobs">
									<div class="job-names">
										<span class="job-name">项目经理</span>
										<span class="job-name">专业监理</span>
										<span class="job-name">专业监理1</span>
									</div>

									<div class="job-count">
										<span class="num">12个</span>
										热招职位
									</div>
								</div>
							</div>

							<!-- 查看更多按钮 -->
							<button class="view-more-btn" type="button">查看更多</button>
						</div>
					</div>

					<!-- 广告位 -->
					<div class="poster-container">
						<img src="@/assets/poster/poster-employment_01.jpg" alt="新用户福利缤纷好礼" />
					</div>

					<!-- 广告位 -->
					<div class="poster-container">
						<img src="@/assets/poster/poster-employment_02.jpg" alt="新用户福利缤纷好礼" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import JrTable from '@/components/JrTable'

	// 企业详情
	export default {
		name: 'CompanyDetail',
		components: {
			JrTable
		},
		props: {},
		data() {
			return {
				// 当前激活的选项
				activeTab: 0,
				// tab选项
				compantTabs: [
					{
						name: '企业资质',
						num: 18
					},
					{
						name: '项目业绩',
						num: 32
					},
					{
						name: '诚信记录',
						num: 2
					}
				],
				// 当前用户对应的所有证书资质
				qualificationAllList: [
					{
						certificateType: '设计资质',
						certificateNo: 'A******',
						qualificationName: '工程设计建筑行业(建筑工程)乙级',
						issueDate: '2023-12-22',
						expiryDate: '2028-12-22',
						issuingAuthority: '住房和城乡建设部'
					},
					{
						certificateType: '建筑业企业资质',
						certificateNo: 'D******',
						qualificationName: '市政公用工程施工总承包二级',
						issueDate: '2023-12-22',
						expiryDate: '2028-12-22',
						issuingAuthority: '湖北省住房和城乡建设厅'
					},
					{
						certificateType: '设计资质',
						certificateNo: 'A******',
						qualificationName: '工程设计建筑行业(建筑工程)乙级',
						issueDate: '2023-12-22',
						expiryDate: '2028-12-22',
						issuingAuthority: '住房和城乡建设部'
					}
				],
				qualificationColumns: [
					{ label: '证书类别', prop: 'certificateType', align: 'center' },
					{ label: '证书编号', prop: 'certificateNo', align: 'center' },
					{ label: '资质名称', prop: 'qualificationName', align: 'center' },
					{ label: '发证日期', prop: 'issueDate', align: 'center' },
					{ label: '发证有效期', prop: 'expiryDate', align: 'center' },
					{ label: '发证机关', prop: 'issuingAuthority', align: 'center' }
				]
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/employment.scss';
	@import '~@/styles/tab-pane.scss';

	.company-detail-container {
		background-color: #eff6f9;
		padding: 20px 0;
		.conpany-detail-content {
			width: $main-page-width;
			margin: 0 auto;

			// 企业信息卡片
			.conpany-card {
				display: flex;
				justify-content: space-between;
				align-items: center;
				background-color: #fff;
				padding: 20px;
				margin-bottom: 20px;

				.company-info-left {
					display: flex;
					flex: 1;
					margin-right: 10px;

					.company-logo {
						width: 120px;
						height: 120px;
						margin-right: 20px;
						border: solid 1px #236fca;
						border-radius: 6px;
						overflow: hidden;

						img {
							width: 100%;
							height: 100%;
							object-fit: contain;
						}
					}

					.company-info-content {
						flex: 1;

						.company-name-wrapper {
							display: flex;
							align-items: center;
							margin-bottom: 10px;

							.company-name {
								font-size: 24px;
								font-weight: bold;
								color: #333;
								word-break: break-all;
								margin: 0;
								margin-right: 15px;
							}

							.company-join-time {
								min-width: 165px;
								font-size: 14px;
								color: #ffffff;
								background-color: #2599fb;
								padding: 2px 10px;
								border-radius: 0px 10px 0 10px;
							}
						}

						.company-meta {
							margin-bottom: 15px;

							.meta-item {
								font-size: 18px;
								color: #999999;
								margin-right: 30px;
								position: relative;

								&:not(:last-child):after {
									content: '|';
									position: absolute;
									right: -15px;
									color: #999999;
								}
							}
						}

						.company-tags {
							display: flex;
							flex-wrap: wrap;

							.company-tag {
								background-color: #daeaff;
								color: #1e94f8;
								padding: 4px 12px;
								border-radius: 4px;
								font-size: 14px;

								& + .company-tag {
									margin-left: 10px;
								}
							}
						}
					}
				}

				.company-info-right {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;

					.job-count {
						display: flex;
						align-items: baseline;
						margin-bottom: 30px;

						.count-num {
							font-size: 42px;
							font-weight: bold;
							color: #236fca;
							margin-right: 10px;
						}

						.count-text {
							font-size: 16px;
							color: #236fca;
						}
					}

					.collect-btn {
						display: flex;
						align-items: center;
						justify-content: center;
						padding: 5px 30px;
						background-color: #fff;
						color: #236fca;
						border: 1px solid #236fca;
						border-radius: 4px;
						font-size: 18px;
						cursor: pointer;
						transition: all 0.3s;

						.svg-icon {
							margin-right: 5px;
							font-size: 18px;
						}

						&:hover {
							background-color: #f0f7ff;
						}
					}
				}
			}

			.section-detail-left {
				.section-info {
					.tab-pane-header {
						.tab-pane-navs {
							.tab-pane-item {
								font-size: 16px;
							}
						}
					}

					.tab-pane-content {
						.tab-pane-content__item {
							::v-deep .table-container {
								padding: 0;
								border-radius: unset;

								.el-table {
									border: solid 1px #e3eef9;
									border-radius: unset;

									.default-th {
										background-color: #dceaf7;
										color: #2e679f;
									}

									td.el-table__cell,
									th.el-table__cell.is-leaf {
										border-color: #e3eef9;
									}

									&.el-table--border .el-table__cell,
									.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
										border-right: solid 1px #e3eef9;
									}
								}
							}
						}
					}
				}
			}

			.section-detail-right {
				.recommendation-card {
					background-color: #fff;
					margin-bottom: 20px;
					padding: 20px;
				}

				.recommendation-company-list {
					min-height: 500px;
					max-height: 500px;
					overflow: hidden;
					position: relative;

					/* 添加蒙层 */
					&::after {
						content: '';
						position: absolute;
						bottom: 0;
						left: 0;
						right: 0;
						height: 90px; /* 蒙层高度，可以根据需要调整 */
						background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.9));
						pointer-events: none; /* 确保蒙层不会阻止点击 */
					}

					/* 查看更多按钮 */
					.view-more-btn {
						position: absolute;
						bottom: 0;
						left: 50%;
						transform: translateX(-50%);
						z-index: 10;
						background-color: #236fca;
						color: white;
						border: none;
						border-radius: 4px;
						padding: 10px 30px;
						font-size: 16px;
						cursor: pointer;
						box-shadow: 0 2px 8px rgba(37, 153, 251, 0.3);

						&:hover {
							background-color: #1e8ae0;
						}
					}

					.company-item {
						padding: 20px 0;
						background-color: #f1f7ff;
						border-radius: 4px;
						padding: 15px;
						transition: all 0.3s ease;
						cursor: pointer;

						&:hover {
							transform: translateY(-5px);
							box-shadow: 0 5px 15px rgba(37, 153, 251, 0.2);
						}

						& + .company-item {
							margin-top: 15px;
						}

						.company-name {
							font-size: 18px;
							font-weight: bold;
							color: #333;
							margin-bottom: 10px;
						}

						.company-meta {
							font-size: 14px;
							color: #999;
							margin-bottom: 10px;

							span {
								margin-right: 5px;
							}
						}

						.company-jobs {
							display: flex;
							justify-content: space-between;
							align-items: center;

							.job-names {
								flex: 1;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;

								.job-name {
									color: #236fca;
									font-size: 14px;

									&:not(:last-child)::after {
										content: '、';
										color: #236fca;
									}
								}
							}

							.job-count {
								color: #333333;
								font-size: 14px;
								white-space: nowrap;
								margin-left: 10px;

								.num {
									color: #ff5013;
								}
							}
						}
					}
				}
			}
		}
	}
</style>
